// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".c-logo{width:9.125rem;height:1.9375rem}.c-logo svg{width:100%;height:100%}", "",{"version":3,"sources":["/usr/src/app/src/components/Logo/Logo.scss"],"names":[],"mappings":"AACA,QACI,cAAA,CACA,gBAAA,CAEA,YACI,UAAA,CACA,WAAA","file":"Logo.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.c-logo {\n    width: (146rem/16);\n    height: (31rem/16);\n\n    svg {\n        width: 100%;\n        height: 100%;\n    }\n}\n"]}]);
// Exports
module.exports = exports;
